/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { makeAutoObservable } from "mobx"

import type { ApplicationType } from "../application-type/application-type-types"

import type { UserAppTypesState } from "./user-types"

export class UserAppTypeStore {
    userAppTypes: Record<number, ApplicationType[]> = {} // so we don't display apps for previously displayed user
    userAppTypesFetchState: UserAppTypesState = "not-fetched"

    constructor() {
        makeAutoObservable(this, {
            setUserAppTypesForUser: true,
            setUserAppTypesFetchStateForUser: true
        })
    }

    setUserAppTypesForUser(userId: number, userAppTypes: ApplicationType[]): void {
        this.userAppTypes[userId] = userAppTypes
        this.setUserAppTypesFetchStateForUser(userId)
    }

    setUserAppTypesFetchStateForUser(userId: number, state?: UserAppTypesState): void {
        if (state) {
            this.userAppTypesFetchState = state
        } else {
            const apps = this.userAppTypes[userId]
            this.userAppTypesFetchState = apps.length === 0 ? "empty" : "has-app-types"
        }
    }

    getUserAppTypes(userId: number): ApplicationType[] {
        return this.userAppTypes[userId]
    }

    getUserAppTypesFetchState(): UserAppTypesState {
        return this.userAppTypesFetchState
    }
}
